export enum ResultsState {
  Complete = 'Approved',
  Failed = 'Failed',
  PendingVerification = 'PendingVerification',
  /**
   * View-only status returned while a data access request is still being prepared server-side.
   * It is never persisted, and such requests cannot be reviewed until they turn pending.
   */
  Preparing = 'Preparing',
  Processing = 'Processing',
  Rejected = 'Rejected'
}

export enum ResultsType {
  Analysis = 'analysis',
  FilesFolders = 'filesFolders'
}

export enum DateTimeFormats {
  Date = 'YYYY-MM-DD',
  Time = 'HH:mm:ss',
  DateTime = 'YYYY-MM-DD HH:mm:ss'
}

export enum Providers {
  AWS = 'AWS',
  Azure = 'Azure',
  GCP = 'GCP'
}

export enum SubscriptionStatuses {
  Approved = 'Approved',
  Rejected = 'Rejected',
  Pending = 'Pending',
  ReSubmitted = 'ReSubmitted'
}

export enum ResponsiveBreakpoints {
  Medium = 905,
  Large = 1240
}

export enum DownloadFileMethods {
  DownloadInTabWithWindowOpen = 'DownloadInTabWithWindowOpen',
  DownloadInTabWithHiddenLink = 'DownloadInTabWithHiddenLink',
  DownloadDirectlyWithHiddenLink = 'DownloadDirectlyWithHiddenLink'
}

export enum CurrencyCodes {
  USD = 'USD',
  USDcents = 'USDcents',
  GBP = 'GBP'
}

export enum ExportRequestStatuses {
  Approved = 'Approved',
  Rejected = 'Rejected',
  Pending = 'Pending'
}

export enum HttpStatusCodes {
  OK = 200,
  Created = 201,
  NoContent = 204,
  BadRequest = 400,
  Unauthorized = 401,
  Forbidden = 403,
  NotFound = 404,
  Conflict = 409,
  InternalServerError = 500
}

export enum FileTypes {
  CSV = 'csv',
  DOCX = 'docx',
  HTML = 'html',
  JPEG = 'jpeg',
  JPG = 'jpg',
  JSON = 'json',
  LOG = 'log',
  PDF = 'pdf',
  PNG = 'png',
  SVG = 'svg',
  TSV = 'tsv',
  TXT = 'txt',
  XLSX = 'xlsx',
  XLS = 'xls'
}

export enum LoginTypes {
  MagicLink = 'magic-link'
}

export enum ValidationStatuses {
  Verified = 'Verified',
  NotChecked = 'NotChecked',
  AutoCheckInProgress = 'AutoCheckInProgress',
  AutoCheckPassed = 'AutoCheckPassed',
  AutoCheckFailed = 'AutoCheckFailed',
  ReRequestAutoApproved = 'ReRequestAutoApproved'
}
